import UploadProvider, { useUploadState, useUploadActions } from './Provider';

export default UploadProvider;
export { useUploadState, useUploadActions };
